import { min, max } from "d3";
import { deepcopy } from "../utility.js";
export let FirstMenuData = {
  name: 'data',
  title: 'Manage data',
  shortcut: 'd'
}

export function setData(data) {
  let header = data.slice(0, Math.min(data.length, 5));
  let stats = getDatasetInfo(data);
  let columns = Object.keys(stats);
  // todo: data type inspection; columns;
  return { header, stats, columns };
}

export function getDatasetInfo(dataset) {
  let dataInstance = {};
  dataset.forEach(row => {
    Object.keys(row).forEach(key => {
      if (!dataInstance.hasOwnProperty(key)) dataInstance[key] = row[key];
    });
  });
  let result = {};
  Object.keys(dataInstance).forEach(fieldName => {
    let stat = getDataStat(dataset.map(d => d[fieldName]));
    result[fieldName] = {
      type: getVegaType(dataInstance[fieldName], fieldName),
      rawType: getRawType(stat.unique[0]),
      entropy: stat.entropy,
      cardinality: stat.cardinality,
      values: stat.unique,
      min: stat.min,
      max: stat.max,
      rawType: getRawType(dataInstance[fieldName])
    }
  });
  return result;
}

export function getVegaType(value, name) {
  if (name == "year") return "nominal";
  if (name == "date") return "temporal";
  if (typeof value == "string") {
    if (!isNaN(Date.parse(value))) return "temporal";
    return "nominal";
  }
  if (typeof value == "number") return "quantitative";
  if (typeof value == "boolean") return "nominal";
  return undefined;
}

export function getRawType(value) {
  return value?.constructor.name;
}

export function getDataStat(values) {
  // @values: an array
  let uniques = Array.from(new Set(values));
  let total = values.length;
  let rel_count = uniques.map(d => values.filter(e => e == d || e === d).length / total);
  let ent = rel_count.reduce((acc, d) => { return acc - d * Math.log2(d) }, 0)
  return {
    entropy: ent,
    cardinality: uniques.length,
    unique: uniques,
    min: min(values),
    max: max(values)
  }
}

export const dTypeAbbr = {
  "quantitative": "Q",
  "temporal": "T",
  "nominal": "N",
  "ordinal": "O",
  "count": "C"
}

export const dTypeIcon = {
  "quantitative": "123",
  "temporal": "calendar3",
  "nominal": "tags-fill",
  "ordinal": "list-ol",
  "count": "calculator"
}

export const dTypeEmoji = {
  "quantitative": "🔢",
  "temporal": "📆",
  "nominal": "🏷",
  "ordinal": "📶",
  "count": "🧮"
}

export const aggregateTypes = [
  { name: "Count", value: "count" },
  { name: "Sum", value: "sum" },
  { name: "Mean", value: "mean" },
  { name: "Median", value: "median" },
  { name: "Min", value: "min" },
  { name: "Max", value: "max" },
  { name: "Arg-min", value: "argmin" },
  { name: "Arg-max", value: "argmax" },
  { name: "Product", value: "product" }
];

export function getFieldDataType(fieldName, dataInfo) {
  let values;
  if ((values = dataInfo?.stats[fieldName]?.values, values) !== undefined) {
    if (values.every(d => d.constructor.name === "Number")) return "number";
    else if (values.every(d => d.constructor.name === "String")) return "text";
  } else return "unkonwn"
}

export function getPreviewData(data, slice) {
  // returns rows sorted by # of missing rows;
  let copy = deepcopy(data);
  function nMissingValues(v) {
    return Object.keys(v).map(k => v[k] === undefined ? 0 : 1).reduce((a, c) => a + c, 0);
  }
  copy = copy.sort((a, b) => {
    return nMissingValues(b) - nMissingValues(a);
  });
  if (!slice) return copy;
  else return copy.slice(0, slice);
}